import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    alert: {
      show: false,
      message: String,
      type: String
    },
    user: {
      full_name: String,
      user_type: Array,
      is_verified: Boolean
    },
    is_logged_in: Boolean,
    selected_paziente: {
      nome: String,
      cognome: String
    },
    selected_dottore: {
      nome: String,
      cognome: String,
      uid: String
    },
    dashboard_toggle: true
  },
  mutations: {
    setAlert(state, payload) {
      state.alert.show = true;
      state.alert.message = payload.message;
      state.alert.type = payload.type;
    },
    removeAlert(state) {
      state.alert.show = false;
      state.alert.message = null;
      state.alert.type = null;
    },
    setUserType(state, userType) {
      state.user.user_type = userType;
    },
    setUser(state, payload) {
      state.user.user_type = payload.user_type;
      state.user.full_name = payload.full_name;
      state.user.is_verified = payload.is_verified;
      state.is_logged_in = true;
    },
    logOut(state) {
      state.user.user_type = null;
      state.user.full_name = null;
      state.is_logged_in = false;
    },
    setPaziente(state, payload) {
      state.selected_paziente.nome = payload.nome;
      state.selected_paziente.cognome = payload.cognome;
    },
    setDottore(state, payload) {
      state.selected_dottore.nome = payload.nome;
      state.selected_dottore.cognome = payload.cognome;
      state.selected_dottore.uid = payload.uid;
    },
    toggleDashboard(state, payload) {
      state.dashboard_toggle = payload;
    }
  },
  actions: {
    setAlert(context, payload) {
      context.commit("setAlert", payload);
    },
    removeAlert(context) {
      context.commit("removeAlert");
    },
    setUserType(context, userType) {
      context.commit("setUserType", userType);
    },
    setUser(context, payload) {
      context.commit("setUser", payload);
    },
    logOut(context) {
      context.commit("logOut");
    },
    selectPaziente(context, payload) {
      context.commit("setPaziente", payload);
    },
    selectDottore(context, payload) {
      context.commit("setDottore", payload);
    },
    toggleDashboard(context, payload) {
      context.commit("toggleDashboard", payload);
    }
  },
  getters: {
    alert(state) {
      return state.alert;
    },
    userType(state) {
      return state.user.userType;
    },
    getUser(state) {
      return state.user;
    },
    isLoggedIn(state) {
      return state.is_logged_in;
    },
    getPaziente(state) {
      return state.selected_paziente;
    },
    getDottore(state) {
      return state.selected_dottore;
    },
    getDashboardToggle(state) {
      return state.dashboard_toggle;
    }
  },
  plugins: [createPersistedState()]
});
